import { Outlet } from 'react-router-dom';
import { useUser } from '@/shared/hooks/useAuth';
import type { Role } from '@/shared/permissions/roles';
import { UnauthorizedPage } from '@/shared/components/Unauthorized';

interface RoleRouteProps {
  roles: Role[];
}

/**
 * Route-level role guard. Authentication is handled upstream by
 * <ProtectedRoute>; this restricts a group of routes to specific roles and
 * renders a clean Unauthorized page otherwise. The backend remains the
 * authoritative gate — this only prevents navigation/UX leaks.
 */
export function RoleRoute({ roles }: RoleRouteProps) {
  const user = useUser();
  if (!user) return null; // ProtectedRoute will have redirected
  return roles.includes(user.role as Role) ? <Outlet /> : <UnauthorizedPage />;
}
